module.exports = __webpack_public_path__ + "media/elevadizo/buqueCargador-di-ap-3c34cef6.png";